import styled, { css } from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  padding: ${Spacing.DOUBLE} ${Spacing.SINGLE_HALF};
  width: 100%;

  ${Mixins.Media.maxWidthSmall(css`
    padding-bottom: 0;
  `)}
`;

export const Results = styled.div`
  ${Mixins.Flex.setColumn()}
`;

export const Header = styled.h3`
  margin: 0 0 ${Spacing.THREE_QUARTERS} !important;
  font-size: ${Font.Size.S} !important;
  ${Font.bySize(Font.Size.S)}
`;

export const ResultButton = styled.button`
  ${Mixins.Flex.set()}
  align-items: center;
  background: none;
  border: none;
  border-radius: ${Border.Radius.M};
  gap: ${Spacing.HALF};
  padding: ${Spacing.QUARTER} ${Spacing.HALF};
  margin: 0 -${Spacing.HALF};

  &:hover {
    background: ${Colors.GRAY_LITE_30};
  }

  ${Mixins.Media.maxWidthSmall(css`
    padding: ${Spacing.THREE_QUARTERS} ${Spacing.HALF};
  `)}
`;

export const ResultText = styled.div`
  ${Font.bySize(Font.Size.S)};
  color: ${Colors.GRAY_DARK_30};
`;
